var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgListIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "ListIcon_svg__a",
  width: 30,
  height: 30,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h30v30H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#ListIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0A1E4C",
  d: "M6.5 28a2.4 2.4 0 0 1-1.766-.734A2.4 2.4 0 0 1 4 25.5V8q0-1.03.734-1.766A2.4 2.4 0 0 1 6.5 5.5h5.25q.406-1.125 1.36-1.812A3.57 3.57 0 0 1 15.25 3q1.188 0 2.14.688A3.75 3.75 0 0 1 18.75 5.5H24q1.032 0 1.766.734Q26.5 6.97 26.5 8v17.5q0 1.032-.734 1.766T24 28zm0-2.5H24V8H6.5zm3.75-2.5h6.25q.531 0 .89-.36.36-.359.36-.89t-.36-.89a1.2 1.2 0 0 0-.89-.36h-6.25q-.531 0-.89.36-.36.359-.36.89t.36.89.89.36m0-5h10q.531 0 .89-.36.36-.359.36-.89t-.36-.89a1.2 1.2 0 0 0-.89-.36h-10q-.531 0-.89.36-.36.359-.36.89t.36.89.89.36m0-5h10q.531 0 .89-.36.36-.359.36-.89t-.36-.89a1.2 1.2 0 0 0-.89-.36h-10q-.531 0-.89.36-.36.359-.36.89t.36.89.89.36m5-5.937a.9.9 0 0 0 .672-.266.9.9 0 0 0 .265-.672.9.9 0 0 0-.265-.672.9.9 0 0 0-.672-.266.9.9 0 0 0-.672.266.9.9 0 0 0-.265.672q0 .406.265.672a.9.9 0 0 0 .672.266"
}))));
export default SvgListIcon;